import { render, staticRenderFns } from "./PollManagement.vue?vue&type=template&id=5f614536&scoped=true&"
import script from "./PollManagement.vue?vue&type=script&lang=js&"
export * from "./PollManagement.vue?vue&type=script&lang=js&"
import style0 from "./PollManagement.vue?vue&type=style&index=0&id=5f614536&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f614536",
  null
  
)

export default component.exports